import { type FC, memo } from 'react';
import './styles.css';
import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';

const BareCollapseNodesIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 16 10' {...props}>
    <path
      d='M16 6.61c0-1.54-1.03-2.82-2.43-3.24A3.389 3.389 0 0010.18 0C9.35 0 8.59.31 8 .81 7.41.31 6.65 0 5.82 0 3.95 0 2.44 1.51 2.43 3.37 1.03 3.79 0 5.07 0 6.61c0 1.84 1.46 3.32 3.29 3.38V10h9.42v-.01A3.384 3.384 0 0016 6.61z'
      fill='currentColor'
      className='svgicon__hiver-hide'
    />
    <path
      d='M16 6.61c0-1.54-1.03-2.82-2.43-3.24A3.389 3.389 0 0010.18 0C9.35 0 8.59.31 8 .81 7.41.31 6.65 0 5.82 0 3.95 0 2.44 1.51 2.43 3.37 1.03 3.79 0 5.07 0 6.61c0 1.84 1.46 3.32 3.29 3.38V10h9.42v-.01A3.384 3.384 0 0016 6.61z'
      fill='currentColor'
      className='svgicon__hiver-hide'
    />
  </SvgWrapper>
);

export const CollapseNodesIcon = memo(BareCollapseNodesIcon);
